import * as formik from 'formik';
import * as fabric from 'office-ui-fabric-react';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import * as api from '../../../../../../api/generated';
import { ILocationItem } from '../../../../../../components/custom/LocationTree';
import KendoLoading from '../../../../../../components/spinners/KendoLoading';
import { IWindowComponentProps } from '../../../../../../components/windows/WindowContext';
import * as enums from '../../../../../../enums';

interface LocationConfigInfoScreenLocationsCreateWindowProps {
    fetchData: () => Promise<void>;
    unselectedLocations: ILocationItem[];
    infoScreenId: number;
}

interface IInfoScreenLocationDisplayItem {
    locationId: number | null;
    direction: enums.InfoScreenLocationDisplayDirectionType;
}

const validationSchema = Yup.object<IInfoScreenLocationDisplayItem>().shape({
    locationId: Yup.number().required('Šis laukas yra privalomas'),
    direction: Yup.number().required('Šis laukas yra privalomas')
});

const LocationConfigInfoScreenLocationsCreateWindow: FC<IWindowComponentProps<LocationConfigInfoScreenLocationsCreateWindowProps>> = (props) => {
    const {
        componentProps: { unselectedLocations, fetchData, infoScreenId },
        onClose
    } = props;

    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (values: IInfoScreenLocationDisplayItem) => {
        setIsLoading(true);
        try {
            await api.administration.createInfoScreenDisplayLocation({ ...values, infoScreenId: infoScreenId });
            toast.success('Atvaizduojama lokacija info ekranui priskirta sėkmingai');
        } catch (ex) {
            toast.error(ex.error[0]);
        } finally {
            setIsLoading(false);
            fetchData();
            onClose();
        }
    };

    const mapLocationsOptions = (unselectedLocations: ILocationItem[]): fabric.IDropdownOption[] => {
        const options: fabric.IDropdownOption[] = [];
        unselectedLocations.map((x) => {
            options.push({ key: x.id.toString(), text: x.name ? x.name : '' });
        });
        return options;
    };

    return (
        <>
            {isLoading ? (
                <KendoLoading />
            ) : (
                <formik.Formik
                    validationSchema={validationSchema}
                    initialValues={{
                        locationId: null,
                        direction: 0
                    }}
                    onSubmit={handleSubmit}
                >
                    {(formikProps) => (
                        <formik.Form>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                                    <formik.Field
                                        name="locationId"
                                        render={({ field, form }: formik.FieldProps<string>) => (
                                            <fabric.Dropdown
                                                defaultSelectedKey={field.value}
                                                label="Lokacija"
                                                options={mapLocationsOptions(unselectedLocations)}
                                                placeholder="Pasirinkite lokaciją"
                                                onChange={({}, option?: fabric.IDropdownOption) =>
                                                    option && form.setFieldValue(field.name, option.key)
                                                }
                                                errorMessage={
                                                    (formikProps.status && formikProps.status.locationId) ||
                                                    (form.errors.locationId && form.errors.locationId)
                                                }
                                            />
                                        )}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
                                    <formik.Field
                                        name="direction"
                                        render={({ field, form }: formik.FieldProps<enums.InfoScreenLocationDisplayDirectionType>) => (
                                            <fabric.Dropdown
                                                defaultSelectedKey={field.value}
                                                {...field}
                                                onChange={({}, option?: fabric.IDropdownOption) =>
                                                    option && form.setFieldValue(field.name, option.key)
                                                }
                                                label="Rodyklė"
                                                options={enums.infoScreenLocationDisplayDirectionType.displayTypesArray()}
                                                errorMessage={(formikProps.status && formikProps.status.direction) || form.errors.direction}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                <fabric.PrimaryButton
                                    className="ms-slideRightIn40 ms-textAlignRight"
                                    text="Išsaugoti"
                                    disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
                                    type="submit"
                                />
                            </div>
                        </formik.Form>
                    )}
                </formik.Formik>
            )}
        </>
    );
};

export default LocationConfigInfoScreenLocationsCreateWindow;
